// ***************
// src/services/p_userUtils.js
// objetivo: encriptar e decriptar tokens
// autor: WdePaula / MVinfo 
// data: 18/9/24 | 15h40 - cópia (semelhante à do agendex cliente web) exclusiva para uso somente no prestador
// data: 20/9/24 | 15h36 - o parâmetro "userObject.tipoAtendimento" estava equivocadamente escrito em minúsculo "userObject.tipoatendimento", causando uma falha em p_home.jsx
// ***************




import { decrypt } from './cryptoUtils';

export const p_getUserData = () => {
    const encryptedTokenLG = localStorage.getItem('tokenlg');
    const encryptedTokenAPW = localStorage.getItem('tokenapw');

    if (encryptedTokenLG && encryptedTokenAPW ) {
        try {
            const decryptedTokenLG = decrypt(encryptedTokenLG);
            const decryptedTokenAPW = decrypt(encryptedTokenAPW);

            if (decryptedTokenLG === "true") {
                // Assumindo que decryptedTokenAcw já é um objeto JavaScript
                const userObject = decryptedTokenAPW;
                // console.log('dentro do decrypt p_userUtils: ', userObject);
                return {
                    userId: userObject.id_usuario || 0,
                    emailValidado: userObject.ativa_conta || 0,
                    indEmpresa: userObject.indempresa || 0,
                    validado: userObject.validado || 0, // acrescentado 4/10/24w (0=cpfcnpj não verificado / 1=verificado)
                    bloqueio: userObject.lock || 0, // acrescentado 4/10/24w (0=cpfcnpj não verificado / 1=verificado)
                    tipoAtendimento: userObject.tipoAtendimento || 0, // 0=não tem funcionário / 1=tem funcionários
                    tipoAgenda: userObject.tipoAgenda || 0, // 0=global / 1=individual // 15/10/24w
                    agenda_fechada: userObject.agenda_fechada || 0, // 0=aberta / 1=fechada // 15/10/24w
                    cidade: userObject.cidade || '',
                    TAMANHO_PAGINA: userObject.TAMANHO_PAGINA || 10, // acrescentado tamanho página
                    dias_FimContrato: userObject.diasFimContrato || 0 // mínimo de 0 dia para encerrar contrato 7/12/24w
                };
                 
            } else {
                // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
                return { userId: 0, emailValidado: 0, indEmpresa: 0, validado: 0, bloqueio: 1, tipoAtendimento: 0, tipoAgenda: 0, agenda_fechada: 0, cidade: '', TAMANHO_PAGINA: 10, dias_FimContrato: 0 };

            }
        } catch (error) {
            console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
            return { userId: 0, emailValidado: 0, indEmpresa: 0, validado: 0, bloqueio: 1, tipoAtendimento: 0, tipoAgenda: 0, agenda_fechada: 0, cidade: '', TAMANHO_PAGINA: 10, dias_FimContrato: 0 };
        }
    }

    // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
    return { userId: 0, emailValidado: 0, indEmpresa: 0, validado: 0, bloqueio: 1, tipoAtendimento: 0, tipoAgenda: 0, agenda_fechada: 0, cidade: '', TAMANHO_PAGINA: 10, dias_FimContrato: 0 };
};